import {FooterComponent} from "../member-home/cathaypacific/footer/footer.component";
import {HeaderComponent} from "../member-home/cathaypacific/header/header.component";
import {PromotionComponent} from "../member-home/cathaypacific/promotion/promotion.component";
import {HeaderComponent as HeymaxHeaderComponent} from "../member-home/heymax/header/header.component";
import {HeaderComponent as PalHeaderComponent} from "../member-home/pal/header/header.component";
import {FooterComponent as PalFooterComponent} from "../member-home/pal/footer/footer.component";
import {PromotionComponent as PalPromotionComponent} from "../member-home/pal/promotion/promotion.component";

export enum HOME_PAGE_COMPONENT {
  HEADER = "header",
  RECOMMENED = "recommended",
  LOCATION = "location",
  EXPERIENCES = "experiences",
  INSTANT = "instant",
  TAG_CATEGORIES = "tagCategories",
  MICHELIN = "michelin",
  FOOTER = "footer",
}

export enum BOOKING_DETAILS_COMPONENT {
  PROMOTION = "promotion",
}

export const CUSTOM_MEMBERSHIP_COMPONENTS: Record<string, Record<string, any>> = {
  "cathaypacific": {
    [HOME_PAGE_COMPONENT.HEADER]: HeaderComponent,
    [HOME_PAGE_COMPONENT.FOOTER]: FooterComponent,
    [BOOKING_DETAILS_COMPONENT.PROMOTION]: PromotionComponent,
  },
  "heymax": {
    [HOME_PAGE_COMPONENT.HEADER]: HeymaxHeaderComponent,
  },
  "pal": {
    [HOME_PAGE_COMPONENT.HEADER]: PalHeaderComponent,
    [HOME_PAGE_COMPONENT.FOOTER]: PalFooterComponent,
    [BOOKING_DETAILS_COMPONENT.PROMOTION]: PalPromotionComponent,
  },
}
